// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","nav":"Footer_nav__wm9cf","link":"Footer_link__c7GbB","copyright":"Footer_copyright__XN1Ks"};